import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { toastActions } from 'redux/toasts';
import { useTranslation } from 'react-i18next';
import { Toast } from 'models/toasts';
import iconError from 'assets/images/icon_error.svg';
import { validationToastDisplayTime } from 'constants/toasts';

type PropsType = {
  toast: Toast;
};

const ValidationToast: React.FunctionComponent<PropsType> = ({ toast }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('toast');

  useEffect(() => {
    const { toast_id, content } = toast;
    const { displayTime } = content;
    setTimeout(
      () => {
        displayTime !== Infinity &&
          dispatch(toastActions.removeToast(toast_id));
      },
      displayTime ? displayTime : validationToastDisplayTime
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <React.Fragment>
      <ValidationErrorToastHeader>
        <IconError />
        <Strong className="mr-auto">
          {toast.content.title ? toast.content.title : t('validationError')}
        </Strong>
      </ValidationErrorToastHeader>
      <InfoToastBody className="toast-body">
        {toast.content.message}
      </InfoToastBody>
    </React.Fragment>
  );
};
const Strong = styled.strong`
  color: #ffffff;
`;
const InfoToastBody = styled.div`
  color: #000000;
  white-space: pre-line;
`;
const ValidationErrorToastHeader = styled.div`
  display: flex;
  align-items: center;
  height: 37px;
  padding: 0.25rem 0.75rem;
  background-color: rgba(254, 162, 91, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
`;

const IconError = styled.div`
  width: 23.157px;
  height: 20.444px;
  margin-right: 8px;
  background-image: url(${iconError});
`;
export default ValidationToast;
